import { Client } from '../../backend/models/client';
import { Person } from '../../backend/models/person';
import { Ring } from '../../backend/models/ring';
import { Section } from '../../backend/models/section';
import { Tag } from '../../backend/models/tag';

export type BaseLoaderResult = {
  rings: Ring[];
  sections: Section[];
  tags: Tag[];
  clients: Client[];
  persons: Person[];
};

export const baseUnauthorizedResponse = {
  rings: [],
  sections: [],
  tags: [],
  clients: [],
  persons: [],
} as BaseLoaderResult;
